<div
  class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-40 card"
  *ngIf="currentFicheConseil">
  <div class="flex-vertical gap-32">
    <oui-banner
      *ngIf="isPrefilledFromAnotherFiche"
      class="prefilled-fiche-banner"
      type="complex"
      title="Attention : cette fiche est préremplie à partir d’une autre."
      description="Vérifiez et adaptez les besoins selon le contrat sélectionné."
      [showCloseButton]="false"></oui-banner>

    <div class="flex-horizontal gap-32">
      <div class="flex-vertical gap-8">
        <div class="subtitle-1">Objectifs<span class="color-primary-500">*</span></div>
        <div class="body-2">
          Sélectionnez les objectifs liés au projet de vos investisseurs. <br />Vous ne pouvez sélectionner que des
          objectifs déjà sélectionnés dans le recueil d’informations.<br />
          <a class="body-2 link" (click)="onModifyClick(false)">Mettre à jour dans le recueil d'information</a>
        </div>
      </div>

      <div class="flex-1"></div>
      <div>
        <oui-button type="text" iconPrefix="cached" (click)="updateData()">Actualiser les données</oui-button>
      </div>
    </div>

    <div class="flex-vertical gap-24 rounded with-border padding-24" *ngIf="!isLoading">
      <div class="gap-8 flex-vertical">
        <oui-banner
          title="Pour accéder à l’enveloppe au moins un des objectifs indiqués par * doit être sélectionné pour ce projet."
          declination="alert"
          [showCloseButton]="false">
        </oui-banner>
        <ng-container *ngIf="this.objectifsGroup.hasError('objectifAuMoinsUn') && showAumoinsUnError">
          <span class="oui-error ng-star-inserted">Vous n’avez sélectionné aucun des objectifs obligatoires</span>
        </ng-container>
      </div>

      <oui-slide-toggle
        label="Afficher uniquement les objectifs sélectionnés dans le recueil d’informations."
        (valueChange)="onDisplayObjectifsChange()"
        [(value)]="objectifsService.showKYCSelectedOnly"></oui-slide-toggle>

      <div class="flex-horizontal gap-24">
        <div class="flex-1 flex-vertical gap-24">
          <ng-container *ngFor="let category of leftColumnCategories">
            <span class="subtitle-2 color-on-surface-medium">{{ category.categoryLabel }}</span>
            <ng-container *ngFor="let obj of category.objectifs | orderBy: 'code' : []">
              <ng-container class="objective-item">
                <app-objectif-checkbox
                  *ngIf="obj.isKYCSelected || !objectifsService.showKYCSelectedOnly"
                  [objectifReferentiel]="obj.objectif"></app-objectif-checkbox>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
        <div class="flex-1 flex-vertical gap-24" *ngIf="rightColumnCategories.length > 0">
          <ng-container *ngFor="let category of rightColumnCategories">
            <span class="subtitle-2 color-on-surface-medium">{{ category.categoryLabel }}</span>
            <ng-container *ngFor="let obj of category.objectifs | orderBy: 'code' : []">
              <ng-container class="objective-item">
                <app-objectif-checkbox
                  *ngIf="obj.isKYCSelected || !objectifsService.showKYCSelectedOnly"
                  [objectifReferentiel]="obj.objectif"></app-objectif-checkbox>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-vertical gap-24">
    <div class="subtitle-1">Horizon de placement</div>
    <div class="flex-horizontal gap-24">
      <oui-select
        class="flex-1"
        [control]="horizonControl"
        label="Horizon de placement"
        [options]="horizonOptions"
        #horizonPlacementField></oui-select>
      <div class="flex-1">
        <oui-textfield
          class="flex-1"
          label="Horizon retraite"
          type="number"
          [step]="retraiteNumberStep"
          textSuffix="an(s)"
          [control]="retraiteControl"
          *ngIf="shouldShowRetraiteField()"
          #retraiteField></oui-textfield>
      </div>
    </div>
    <div class="flex-vertical gap-8" *ngIf="horizonJustificationControl.isVisible() && isHorizonOtherThanRetraite">
      <div class="body-1">
        L’horizon de placement qui est en principe « Retraite » pour un contrat retraite n’a pas été sélectionné.
        Veuillez reprendre la justification qui sera reprise dans la fiche conseil :
      </div>
      <oui-textarea
        [control]="horizonJustificationControl"
        label="Votre justification"
        [errors]="requiredErrors"
        [resizeEnabled]="true"></oui-textarea>
    </div>
  </div>
  <div class="flex-vertical gap-24">
    <span class="subtitle-1">Disponibilité de l'épargne<span class="color-primary-500">*</span></span>
    <oui-radio-list [control]="dispoEpargneControl" [errors]="dispoEpargneErrors">
      <oui-radio-button *ngFor="let option of disponibiliteOptions" [value]="option.value">
        <div class="example-radio-list-item-content">
          <div>{{ option.label }}</div>
        </div>
      </oui-radio-button>
    </oui-radio-list>
  </div>
  <div class="flex-vertical gap-24">
    <span class="subtitle-1">Profil de risque du projet<span class="color-primary-500">*</span></span>
    <oui-radio-list [control]="toleranceRisqueControl" [errors]="requiredErrors">
      <oui-radio-button *ngFor="let option of toleranceRisqueOptions" [value]="option.value">
        <div class="example-radio-list-item-content">
          <div>{{ option.label }}</div>
        </div>
      </oui-radio-button>
    </oui-radio-list>
  </div>
</div>
